import { c as _c } from "react/compiler-runtime";
import AIHighlightIcon from '@precis-digital/kurama/icons/AIHighlightIcon';
import Chip from '@precis-digital/kurama/Chip';
import { CopilotActionCard } from '@precis-digital/kurama/MessageLayout';
import { type ReactElement } from 'react';
import { getPageElementIcon, getPageElementLabel } from 'shared/copilot/components/ToolCall/pageElementDisplay';
import type { CopilotPageElement } from '../../../pageContext/types';
import { useTranslation } from 'shared/translations';
interface HighlightElementToolCallCardProps {
  elementId: string | undefined;
  elements: CopilotPageElement[] | undefined;
  onShowOnPage: () => void;
}

/**
 * Visible card for the `highlight_element` frontend tool.
 */
const HighlightElementToolCallCard = t0 => {
  const $ = _c(11);
  const {
    elementId,
    elements,
    onShowOnPage
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "copilot.toolCall.highlightElement"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("common", t1);
  let t2;
  if ($[1] !== elementId || $[2] !== elements || $[3] !== onShowOnPage || $[4] !== t) {
    const targetLabel = getPageElementLabel(elementId, elements);
    const showOnPageAriaLabelParams = {
      target: targetLabel
    };
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <AIHighlightIcon />;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    let t4;
    if ($[7] !== t) {
      t4 = t("highlighted");
      $[7] = t;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    let t5;
    if ($[9] !== elementId) {
      t5 = getPageElementIcon(elementId);
      $[9] = elementId;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    t2 = <CopilotActionCard icon={t3} label={t4} detail={<Chip avatar={t5} label={targetLabel} />} onHighlight={onShowOnPage} highlightAriaLabel={t("showOnPageAriaLabel", showOnPageAriaLabelParams)} />;
    $[1] = elementId;
    $[2] = elements;
    $[3] = onShowOnPage;
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default HighlightElementToolCallCard;